/* eslint-disable @next/next/no-img-element */
import { FC } from 'react';

import { Container } from './styles';

import { Header } from './Header';
import { Body } from './Body';

export const CallMapBoard: FC = () => (
  <Container>
    <Header />
    <Body />
  </Container>
);
